import UIkit from './UIkit';

const initSlideshows = () => {
  const pauseSlider = document.querySelector('.stop-autplay');

  UIkit.util.on('.uk-slider-items', 'beforeitemshow', function (e) {
    const index = parseInt(e.target.dataset.slideIndex) + 1;
  });

  if (pauseSlider) {
    pauseSlider.addEventListener('click', function () {
      pauseSlider.classList.toggle('paused');

      if (pauseSlider.classList.contains('paused')) {
        UIkit.slider(element).stopAutoplay();
      } else {
        UIkit.slider(element).startAutoplay();
      }
    });
  }
};

export default initSlideshows;
